/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum EntityElementTypeEnum {
    PATH = 'path',
    CONNECTION = 'connection',
    POOL = 'pool'
}
